import { render, staticRenderFns } from "./PRBusiness.vue?vue&type=template&id=067313a3&scoped=true&"
import script from "./PRBusiness.vue?vue&type=script&lang=js&"
export * from "./PRBusiness.vue?vue&type=script&lang=js&"
import style0 from "./PRBusiness.vue?vue&type=style&index=0&id=067313a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067313a3",
  null
  
)

export default component.exports